module.exports = __webpack_public_path__ + "img/show-exam.250de91f.png";